<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import Fa from 'svelte-fa'
    import { faTrashAlt, faSave } from '@fortawesome/free-solid-svg-icons'
    import { BalancesRepository } from '../../modules/posApi/balances/balances.repository'
    import { BalancesService } from '../../modules/posApi/balances/balances.service'
    import type { CreateBalanceDto } from '../../modules/posApi/balances/dto/create-balance.dto'
    import LoadSpinner from '../_common/load-spinner.svelte'

    const dispatch = createEventDispatcher()

    const rep = new BalancesRepository()
    const service = new BalancesService(rep)

    export let personId: string
    export let serviceId: string
    export let parentServicesOnInvoicesId: string
    export let balance: number
    export let balanceId: string = null
    let value: number = null

    let show = false

    onMount(async () => {})

    async function saveEntity() {
        if (show) return
        if (value === null) {
            evaluateError('Informe o novo saldo')
            return
        }
        show = true
        await createEntity()
        // como o cálculo do saldo é async no servidor, então dá tempo para ele calcular
        setTimeout(() => {
            show = false
            dispatch('change')
        }, 5000)
    }

    async function createEntity() {
        try {
            let dto: CreateBalanceDto = {
                personId,
                parentServicesOnInvoicesId,
                serviceId,
                value: value - balance,
            }
            if (!validateDto(dto)) return false
            if (dto.value !== 0) {
                await service.create(dto)
            }
        } catch (error) {
            evaluateError(error)
        } finally {
        }
    }

    function validateDto(dto) {
        if (!dto.personId) {
            evaluateError('Selecione o cliente')
            return false
        }
        if (!dto.serviceId) {
            evaluateError('Informe o serviço')
            return false
        }
        return true
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await service.remove(balanceId)
            setTimeout(() => {
                dispatch('change')
            }, 5000)
        } catch (error) {
            evaluateError(error)
        } finally {
        }
    }

    function evaluateError(error) {
        window.error(error)
    }
</script>

<div class="root m-bottom-sm">
    <div class="grid-act">
        <div class="spacer" />
        {#if window.store.token.permissions.pos.sales.write}
            {#if !!balanceId}
                <button class="btn btn-warning" on:click={removeEntity}><Fa icon={faTrashAlt} /> Excluir</button>
            {:else}
                <button class="btn btn-primary" on:click={saveEntity}><Fa icon={faSave} /> Salvar</button>
            {/if}
        {/if}
    </div>
    <div class="grid-form">
        <div class="row">
            <div class="col">
                <div class="input-group">
                    <label for="" class="input-group-text">Falta agendar</label>
                    <input type="number" bind:value class="form-control" />
                </div>
            </div>
        </div>
    </div>
</div>
<LoadSpinner {show} delay={0} />

<style>
    .row {
        padding: 0px 16px;
    }

    @media (max-width: 900px) {
        .root {
            display: flex;
            flex-direction: column-reverse;
        }
        .grid-act {
            background-color: unset;
            display: flex;
            justify-content: space-around;
        }
        .grid-act .btn {
            max-width: 120px;
            flex-grow: 1;
        }
    }
</style>
